import React, { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n/translations";
import Header from "../components/application/Header";
import Footer from "../components/application/Footer";
import DateModified from "../components/common/dateModified";
 
const MaintenancePage: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const maintenanceDateFrom =
    import.meta.env.VITE_MAINTENANCE_DATEFROM || t.maintenanceStartDate;
  const maintenanceDateTo =
    import.meta.env.VITE_MAINTENANCE_DATETO || t.maintenanceEndDate;

  const renderMaintenanceMessage = () => {
    const [beforeStart, afterStart] = t.maintenanceNoticeMessage.split("{startDate}");
    const [betweenDates, afterEnd] = afterStart.split("{endDate}");

    return (
      <>
        {beforeStart}
        <strong>{maintenanceDateFrom}</strong>
        {betweenDates}
        <strong>{maintenanceDateTo}</strong>
        {afterEnd}
      </>
    );
  };
 
  // Set document title
  useEffect(() => {
    document.title = t.maintenancePageTitle;
  }, [t.maintenancePageTitle]);
 
  // Render desktop mode
  if (!isMobile) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-blue-50">
        <a href="#main-content" className="skip-link">
          {t.skipToMainContent}
        </a>
        {/* Header */}
        <Header />
 
        {/* Main Content Section */}
        <main className="max-w-7xl mx-auto px-4 py-2 mb-28">
          {/* Page Title Section */}
          <div className="bg-white py-8">
            <h1 id="main-content" tabIndex={-1} className="text-4xl font-bold text-gray-900 mb-2">{t.defenceTeamCareers}</h1>
            <div className="w-24 h-1 bg-red-600"></div>
          </div>

          <div className="max-w-3xl space-y-6">
            {/* Danger Alert for Maintenance Notice */}
            <section className="alert alert-warning">
              <h2 className="h3">
                <strong>{t.maintenanceNoticeTitle}</strong>
              </h2>
              <p className="text-lg text-gray-900">
                {renderMaintenanceMessage()}
              </p>
              <p className="text-lg text-gray-900">{t.maintenanceApology}</p>
            </section>
          </div>
        </main>
 
        <DateModified />
        <Footer />
      </div>
    );
  } else {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-blue-50">
        <a href="#main-content" className="skip-link">
          {t.skipToMainContent}
        </a>
        <Header />
 
        {/* Main Content Section */}
        <main className="max-w-7xl mx-auto px-4 py-2 mb-28">
          {/* Page Title Section */}
          <div className="bg-white py-3">
            <h1 id="main-content" tabIndex={-1} className="text-4xl font-bold text-gray-900">{t.defenceTeamCareers}</h1>
            <div className="w-24 h-1 bg-red-600"></div>
          </div>

          <div className="max-w-3xl space-y-6">
            {/* Danger Alert for Maintenance Notice */}
            <section className="alert alert-warning">
              <h2 className="h3">
                <strong>{t.maintenanceNoticeTitle}</strong>
              </h2>
              <p className="text-lg text-gray-900">
                {renderMaintenanceMessage()}
              </p>
              <p className="text-lg text-gray-900">{t.maintenanceApology}</p>
            </section>
          </div>
        </main>
 
        <DateModified />
        <Footer />
      </div>
    );
  }
};
 
export default MaintenancePage;